module.exports = __webpack_public_path__ + "static/img/img-p1-2.d0b0ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buyone365/img-p1-2.jpg
// module id = /FBG
// module chunks = 0